<template>
  <div>
    <a-input
        placeholder="请选择代销合同"
        v-model="chosenShowName"
        disabled
        v-if="isShowInput">
      <template #suffix>
        <a-button type="primary" @click="startChoose"
                  v-if="$route.query.type !== 'view'" :disabled="isDisabled">选择</a-button>
      </template>
    </a-input>
    <a-modal v-if="choosing || isShowModel" :visible="true" title="请选择代销合同" :footer="null"
             @cancel="onCancel" :width="1180" wrap-class-name="consign-contract-dialog">
      <div class="table-header">
        <a-form layout="inline">
          <a-form-item label="合同号">
            <a-input v-model="contractNoKw" :disabled="!searchable"
                     @keyup.enter.native="onSearch" placeholder="模糊搜索" allowClear style="width: 180px"/>
          </a-form-item>
          <a-form-item label="文本协议号">
            <a-input v-model="textContractNoKw" :disabled="!searchable"
                     @keyup.enter.native="onSearch" allowClear style="width: 160px"/>
          </a-form-item>
          <a-form-item label="电商编号">
            <a-input :value="mchNo" disabled style="width: 160px"/>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="onSearch">查询</a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="onReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="table-main">
        <a-table :columns="columns" :data-source="data" :pagination="false"
                 row-key="contractNo" size="small" :scroll="{ x: 1180 }">
          <span slot="contractInfo" slot-scope="text, record">
            <div class="cell-main">{{ record.contractNo }}</div>
            <div class="cell-sub" v-if="record.textContractNo">文本号:{{ record.textContractNo }}</div>
          </span>
          <span slot="mchInfo" slot-scope="text, record">
            <div class="cell-main">{{ record.mchNo }}</div>
            <div class="cell-sub" v-if="record.mchName">{{ record.mchName }}</div>
            <div class="cell-sub cell-empty" v-else>----</div>
          </span>
          <span slot="consignAccount" slot-scope="text, record">
            <div class="cell-main cell-ellipsis" :title="record.consignAccountName">
              {{ record.consignAccountName || '----' }}
            </div>
            <div class="cell-sub cell-ellipsis" :title="record.consignAccountNo">
              {{ record.consignAccountNo || '----' }}
            </div>
          </span>
          <span slot="consignLimit" slot-scope="text">
            <Balance :amount="text" dcflag="c" />
          </span>
          <span slot="status" slot-scope="text">
            <a-tag v-if="text === '2'" color="green">审批通过</a-tag>
            <a-tag v-else-if="text === '1'" color="blue">待审批</a-tag>
            <a-tag v-else-if="text === '3'" color="red">审批拒绝</a-tag>
            <a-tag v-else-if="text === '4'" color="default">已作废</a-tag>
            <a-tag v-else color="orange">草稿</a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a-button @click="onChoose(record)" type="primary" size="small">选择</a-button>
          </span>
        </a-table>
      </div>
      <div class="paginationBox">
        <a-pagination v-model="pageNo" :total="total" :page-size="pageSize"
                      @change="onPagesizeChange" show-quick-jumper>
        </a-pagination>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Balance from '@/view/components/Balance.vue'

export default {
  name: 'ConsignContractChooseDialog',
  components: { Balance },
  model: {
    prop: 'chosenShowName',
    event: 'change'
  },
  props: {
    scope: {
      required: false,
      type: Object,
    },
    chosenShowName: {
      required: false,
      type: String,
      default: '',
    },
    mchNo: { // 电商编号(必传,自动注入查询)
      required: true,
      type: String,
    },
    searchable: {
      required: false,
      type: Boolean,
      default: true,
    },
    isShowInput: {
      required: false,
      type: Boolean,
      default: true,
    },
    isShowModel: {
      required: false,
      type: Boolean,
      default: false,
    },
    isDisabled: Boolean,
  },
  data() {
    return {
      choosing: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      data: [],
      contractNoKw: '',       // 合同号模糊搜索(本地状态)
      textContractNoKw: '',   // 文本协议号模糊搜索(本地状态)
      columns: [
        { title: '合同号 / 文本协议号', key: 'contractInfo', scopedSlots: { customRender: 'contractInfo' }, width: 240, align: 'left' },
        { title: '电商', key: 'mchInfo', scopedSlots: { customRender: 'mchInfo' }, width: 200, align: 'left' },
        { title: '代销方账户', key: 'consignAccount', scopedSlots: { customRender: 'consignAccount' }, width: 240, align: 'left' },
        {
          title: '协议期间', key: 'dateRange', width: 200, align: 'center',
          customRender: (text, record) =>
              `${record.contractDateStart || '----'} ~ ${record.contractDateEnd || '----'}`,
        },
        {
          title: '年度代销额度', dataIndex: 'consignYearLimit', key: 'consignLimit',
          width: 160, scopedSlots: { customRender: 'consignLimit' }, align: 'right',
        },
        { title: '状态', dataIndex: 'status', key: 'status', width: 100, scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 80, align: 'center', fixed: 'right' },
      ],
    }
  },
  watch: {
    // 切换电商后刷新列表
    mchNo() {
      this.pageNo = 1
      if (this.choosing || this.isShowModel) this.loadTableData()
    },
  },
  created() {
    if (this.isShowModel) this.loadTableData()
  },
  methods: {
    startChoose() {
      this.choosing = true
      this.loadTableData()
    },
    onSearch() {
      this.pageNo = 1
      this.loadTableData()
    },
    async loadTableData() {
      if (!this.mchNo) {
        this.$message.warning('请先选择电商')
        this.data = []
        this.total = 0
        return
      }
      const res = await this.api.contractPageApi({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        mchNo: this.mchNo,
        contractNo: this.contractNoKw,
        textContractNo: this.textContractNoKw,
        status: '2', // 写死:仅展示审批通过的合同
      })
      if (res.code !== 200) {
        this.$message.error(res.info || '查询代销合同失败')
        return
      }
      this.data = res.data?.records || []
      this.total = res.data?.total || 0
    },
    onChoose(record) {
      this.choosing = false
      // v-model 双向绑定的显示值:合同号
      this.$emit('change', record.contractNo)
      this.$emit('chooseDone', record, this.scope)
    },
    onPagesizeChange(page) {
      this.pageNo = page
      this.loadTableData()
    },
    onReset() {
      this.contractNoKw = ''
      this.textContractNoKw = ''
      this.pageNo = 1
      this.loadTableData()
    },
    onCancel() {
      this.choosing = false
      this.$emit('chooseCancel')
    },
  },
}
</script>

<style lang="less" scoped>
/* modal 宽度:由 :width prop 控(1180),这里收紧内边距 */
::v-deep .consign-contract-dialog .ant-modal-body {
  padding: 16px 20px;
}
::v-deep .consign-contract-dialog .ant-modal-content {
  border-radius: 4px;
}
::v-deep .consign-contract-dialog .ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 600;
  color: #333;
  padding: 8px 12px;
}
::v-deep .consign-contract-dialog .ant-table-tbody > tr > td {
  padding: 8px 12px;
}
::v-deep .consign-contract-dialog .ant-table-tbody > tr:hover > td {
  background: #e6f7ff;
}

.table-header {
  margin-bottom: 12px;
  padding: 12px 14px;
  background: #fafbfc;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  ::v-deep .ant-form-item {
    margin-bottom: 0;
  }
  ::v-deep .ant-form-item-label {
    label {
      color: #666;
      font-size: 13px;
    }
  }
}

.table-main {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.cell-main {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  font-weight: 500;
}
.cell-sub {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  margin-top: 2px;
}
.cell-empty {
  color: #ccc;
}
.cell-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.paginationBox {
  margin: 12px 0 4px;
  display: flex;
  justify-content: flex-end;
}
</style>
